/**
 * CategoryEditView Component
 *
 * View for editing configuration items within a category.
 */

import React from "react";
import { HiArrowLeft } from "react-icons/hi2";

const CategoryEditView = ({ categoryDisplay, configItems, taskConfig, onConfigChange, onBack }) => {
  return (
    <div className="h-full flex flex-col overflow-hidden">
      {/* Category header with icon and name */}
      <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-800 flex-shrink-0">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            className="lg:hidden p-1.5 -ml-1.5 rounded-lg text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
          >
            <HiArrowLeft className="w-4 h-4" />
          </button>
          <div className={`p-1.5 rounded-lg ${categoryDisplay.colorClasses?.bg || "bg-gray-100 dark:bg-gray-800"} ${categoryDisplay.colorClasses?.border ? `border ${categoryDisplay.colorClasses.border}` : ""}`}>
            {categoryDisplay.Icon && (
              <categoryDisplay.Icon className={`w-4 h-4 ${categoryDisplay.colorClasses?.text || "text-gray-500"}`} />
            )}
          </div>
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {categoryDisplay.label}
          </span>
        </div>
      </div>

      {/* Config Items */}
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="space-y-4">
          {configItems.map((configItem) => {
            const itemConfig = taskConfig[configItem.id] || configItem.defaultConfig;
            const ConfigComponent = configItem.Component;
            if (!ConfigComponent) return null;

            return (
              <div key={configItem.id}>
                {configItems.length > 1 && (
                  <div className="flex items-center gap-2.5 mb-3">
                    {configItem.emoji && <span className="text-sm">{configItem.emoji}</span>}
                    <span className="text-sm font-semibold text-gray-600 dark:text-gray-300">{configItem.label}</span>
                    <div className="flex-1 h-px bg-gray-200 dark:bg-gray-700/50" />
                  </div>
                )}
                <ConfigComponent
                  config={itemConfig}
                  onChange={(newConfig) => onConfigChange(configItem.id, newConfig)}
                  taskConfig={taskConfig}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoryEditView;
